function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#282828",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.5 13.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H4a.5.5 0 01-.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 11.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1H4a.5.5 0 01-.5-.5zM3.5 9.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H4a.5.5 0 01-.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 8.5A2.5 2.5 0 016 6h4a2.5 2.5 0 012.5 2.5v5A2.5 2.5 0 0110 16H6a2.5 2.5 0 01-2.5-2.5zM6 7c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5zM8 1a.57.57 0 00-.57.57V3.1l-.35.1v.01a1.04 1.04 0 00-.16.07 2.1 2.1 0 00-.4.24c-.28.22-.52.53-.52.99H5c0-.87.47-1.45.9-1.78.2-.15.38-.26.53-.33v-.82a1.57 1.57 0 013.14 0v.82c.15.07.34.18.52.33.44.33.91.9.91 1.78h-1c0-.46-.24-.77-.52-1a2.1 2.1 0 00-.55-.3l-.36-.11V1.57A.57.57 0 008 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 5.5C4 4.67 4.67 4 5.5 4h5a1.5 1.5 0 110 3h-5A1.5 1.5 0 014 5.5zM5.5 5a.5.5 0 000 1h5a.5.5 0 000-1z"
})));